import Cookies from 'universal-cookie';

import { recalculatePageMargin } from './helpers';

const cookies = new Cookies();

jQuery(function ($) {
  $('.ukhc-alert').each(function (index, item) {
    if (!cookies.get(`alert-${$(item).attr('alert-id')}`)) {
      $(item).css('display', 'flex');
    }
  });

  recalculatePageMargin();

  $('.ukhc-alert--close').on('click', function () {
    const alertID = $(this).parent().attr('alert-id');
    cookies.set(`alert-${alertID}`, 'hidden', {
      path: '/',
      maxAge: 86400,
    });
    $(this).parent().hide();
    recalculatePageMargin();
  });
});
